import { card } from "@universityofmaryland/web-elements-library/composite";
import { createTextContainer, createTimeElement, createTextWithLink } from "@universityofmaryland/web-utilities-library/elements";
const extractLinkUrl = (entry) => entry.externalLink?.link || entry.url || "#";
const extractSummaryText = (entry) => {
  if (!entry.summary) return null;
  return entry.summary.plainText || entry.summary.html || null;
};
const getAttributionText = (entry) => {
  return entry.attribution || null;
};
const getAuthorText = (entry) => {
  return entry.author || null;
};
const formatDate = (dateString) => {
  if (!dateString) return "";
  try {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
  } catch {
    return "";
  }
};
const createHeadlineElement = (entry) => createTextWithLink({
  text: entry.title,
  url: extractLinkUrl(entry),
  openInNewTab: true
});
const createSummaryElement = (entry) => {
  const summary = extractSummaryText(entry);
  const author = getAuthorText(entry);
  const expertName = formatExpertName(entry);
  const hasName = author || expertName;
  if (hasName && summary) {
    const combinedSummary = `<b>${expertName ? expertName : author} |</b> ${summary}`;
    return createTextContainer({ text: combinedSummary, allowHTML: true });
  }
  if (summary && !expertName) {
    return createTextContainer({ text: summary, allowHTML: true });
  }
  return null;
};
const formatExpertName = (entry) => {
  const expert = entry.expert?.[0];
  if (!expert) return null;
  const nameParts = [
    expert.firstName,
    expert.middleName,
    expert.lastName
  ].filter(Boolean);
  return nameParts.length > 0 ? nameParts.join(" ") : expert.title || null;
};
const createAttributionElement = (entry) => {
  const attributionText = getAttributionText(entry);
  if (!attributionText) return null;
  return createTextContainer({ text: attributionText });
};
const createDateElement = (entry) => {
  const dateString = entry.postDate || entry.dateCreated;
  if (!dateString) return null;
  const formattedDate = formatDate(dateString);
  if (!formattedDate) return null;
  return createTimeElement({
    datetime: dateString,
    displayText: formattedDate
  });
};
const inTheNewsDisplayStrategy = {
  layoutType: "grid",
  mapEntryToCard: (entry, options) => {
    const {
      isThemeDark = false,
      isTransparent = false,
      isAligned = true,
      cardType = "block"
    } = options;
    const commonProps = {
      headline: createHeadlineElement(entry),
      text: createSummaryElement(entry),
      date: createDateElement(entry),
      eyebrow: createAttributionElement(entry),
      isThemeDark
    };
    if (cardType === "list") {
      return card.list({
        ...commonProps,
        isAligned: false
      });
    }
    return card.block({
      ...commonProps,
      isAligned,
      isTransparent
    });
  }
};
export {
  inTheNewsDisplayStrategy
};
//# sourceMappingURL=inTheNews.js.map
